import React from 'react';
import { useT } from 'talkr';
import s from './index.module.scss';

import icon from './img/icon.svg';

function RecommendTimesWeek () {
	const { T } = useT();

	return (
		<div className={s.weightRecommendations}>
			<div className={s.titleWrapper}>
				<h2 className={s.title}>{T('choose_days_recommend')}</h2>
				<img className={s.titleIcon} src={icon} alt="" />
			</div>
		</div>
	);
}

export default RecommendTimesWeek;
